export default __webpack_public_path__ + "static/media/CERN.fa4a7a2f.png";